module.exports = __webpack_public_path__ + "static/iphone-2b4b3b1523788f28ca6f066bc048b948.png";